import {
  Backdrop,
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import React, { FC, memo, useState } from 'react';
import { useSelector } from 'react-redux';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { AppState, store, useAppDispatch, useAppSelector } from 'src/store';
import { setDocumentDetail } from 'src/store/documentDetail';
import { setSnackbarMessage } from 'src/store/snackbarMessage';
import DocManagementService from '../documentUpload/service/DocManagementService';

const Remove: FC<any> = ({ openRemoveDialog, setOpenRemoveDialog, props, setDataGridComponent }: any) => {
  const [loading, setLoading] = useState(false);
  const documentDetail: any = useSelector((state: AppState) => state.documentDetail);
  const fileMasterId = documentDetail.data[0]?.fmId;
  const tmfDocId = documentDetail.data[0]?.tmf_document_id;
  const docService = new DocManagementService();
  const user: any = useAppSelector(state => state.user.user);
  const userName = `${user.firstName + ' ' + user.lastName}`;
  const selectedStudy = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Study);
  const selectedCountry = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Country);
  const selectedSite = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Site);

  let TmfLevel =
    (selectedStudy === '--' || selectedStudy === '') &&
    (selectedCountry === '--' || selectedCountry == '') &&
    (selectedSite === '--' || selectedSite === '')
      ? '--'
      : (selectedCountry === '--' || selectedCountry == '') && (selectedSite === '--' || selectedSite === '')
      ? 'Study'
      : selectedSite === '--' && selectedCountry != '--'
      ? 'Country'
      : 'Site';
  if (TmfLevel === '--') {
    TmfLevel = 'Study';
  }
  const dispatch = useAppDispatch();

  const handleDeleteRecord = async (fileMasterId: any, tmfDocId: any, deleteDoc: any) => {
    try {
      setLoading(true);
      const params = {
        module_section_related: 'DocumentDetails',
        parent_entity_related: 'DeleteDocument'
      };
      const response: any = await docService.deleteDocumentDetails(
        fileMasterId,
        tmfDocId,
        deleteDoc,
        selectedStudy,
        selectedCountry,
        selectedSite,
        TmfLevel,
        params
      );
      setLoading(false);
      if (response.data) {
        store.dispatch(setSnackbarMessage('Document is deleted successfully.', 'success'));
      } else {
        store.dispatch(setSnackbarMessage('Error in deleteing document.', 'error'));
      }
      setDocumentDetail(dispatch, [
        {
          ...documentDetail.data[0],
          deletedId: tmfDocId
        }
      ]);
      handleCloseRemoveDialog();
      setDataGridComponent(true);
      props.onClicked(true);
    } catch (e) {
      setLoading(false);
    }
  };

  if (loading)
    return (
      <>
        <Backdrop sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }} open={loading}>
          <CircularProgress />
        </Backdrop>
      </>
    );

  const handleCloseRemoveDialog = () => {
    setOpenRemoveDialog(false);
  };

  const handleDeleteClick = () => {
    const deleteDoc: any = {
      deleted_by: userName
    };
    handleDeleteRecord(fileMasterId, tmfDocId, deleteDoc);
  };

  return (
    <React.Fragment>
      <PopupComponent
        open={openRemoveDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Delete Document`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`Are you sure you want to delete ${documentDetail.data[0]?.tmf_document_name}?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseRemoveDialog} autoFocus>
            CANCEL
          </Button>
          <Button onClick={() => handleDeleteClick()} autoFocus disabled={loading}>
            DELETE
          </Button>
        </DialogActions>
      </PopupComponent>
    </React.Fragment>
  );
};

export default memo(Remove);
